// node modules
import { observable, action } from 'mobx';

export default class BasicStore {
  @observable connected = false;
  @observable failed = false;
  @observable reconnected = false;

  @action setConnectionState = (connected: boolean, failed: boolean) => {
    this.connected = connected;
    this.failed = failed;
  };

  @action setReconnectionStatus = (reconnected: boolean) => {
    this.reconnected = reconnected;
  }
}
